import React from "react";
import { useLocation } from "react-router-dom";
import { sendMotivo } from "../helpers/sendMotivo";
import { useNavigate } from "react-router-dom";

export default function Form2() {
  const location = useLocation();
  const { dealId } = location.state || {};
  const navigate = useNavigate();

  const form2 = async (motivo) => {
    if (!dealId) {
      console.error("Erro: ID do negócio não encontrado");
      alert("Ocorreu um erro ao processar sua resposta. Por favor, tente novamente.");
      return;
    }

    try {
      await sendMotivo(dealId, motivo);
      console.log("Motivo atualizado com sucesso para o deal:", dealId);
      scrollToTop();
      navigate("/obrigado");
    } catch (error) {
      console.error("Erro ao enviar motivo:", error);
      alert("Não foi possível salvar sua resposta. Por favor, tente novamente.");
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="pt-4 bg-slate-300 m-4 border-none rounded-md shadow-md ">
      <h1 className="text-xl text-center py-2 bg-full text-slate-800 font-bold uppercase ">O que você achou da proposta?</h1>
      <div className="p-4  space-y-3 ">
        <button
          className="group w-full mx-auto flex items-center rounded-full border shadow-md border-green-700 bg-green-700 px-4 py-2 font-medium text-white group-hover:text-blue-900 group-active:text-green-600 transition-colors hover:bg-transparent hover:text-green-700 focus:outline-none focus:ring"
          onClick={() => form2("Quer saber mais")}
        >
          <span className="m-2 flex-shrink-0 rounded-full border border-current bg-slate-200 hover:bg-green-700 p-2 text-green-900 group-active:text-green-600"></span>
          Quero saber mais!
        </button>
        <button
          className="group w-full mx-auto flex items-center rounded-full border shadow-md border-green-700 bg-green-700 px-4 py-2 font-medium text-white group-hover:text-green-900 group-active:text-green-600 transition-colors hover:bg-transparent hover:text-green-700 focus:outline-none focus:ring"
          onClick={() => form2("Gostou da proposta")}
        >
          <span className="m-2 flex-shrink-0 rounded-full border border-current bg-slate-200 hover:bg-green-700 p-2 text-green-900  group-active:text-green-600"></span>
          Gostei da proposta!!
        </button>
        <button
          className="group w-full mx-auto flex items-center rounded-full border shadow-md border-green-700 bg-green-700 px-4 py-2 font-medium text-white group-hover:text-green-900 group-active:text-green-600 transition-colors hover:bg-transparent hover:text-green-700 focus:outline-none focus:ring"
          onClick={() => form2("Fora do orçamento")}
        >
          <span className="m-2 flex-shrink-0 rounded-full border border-current bg-slate-200 hover:bg-green-700 p-2 text-green-900 group-active:text-green-600"></span>
          Fora do meu orçamento
        </button>
      </div>
    </div>
  );
}
